// @ts-nocheck

import 'nouislider/distribute/nouislider.css';
import 'bootstrap-slider/dist/css/bootstrap-slider.css';

import 'jquery-bar-rating/dist/themes/css-stars.css';
import 'jquery-bar-rating/dist/themes/fontawesome-stars.css';

import $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-bar-rating';

//import 'icheck/skins/square/blue.css';
import 'pretty-checkbox/dist/pretty-checkbox.css';

import * as widgets from 'surveyjs-widgets';
import geoLocationWidget from './GeoLocationWidget';

const register = (survey: any) => {
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName(geoLocationWidget.name))
    geoLocationWidget.init(survey, $);

  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('autocomplete')) widgets.autocomplete(survey, $);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('barrating')) widgets.jquerybarrating(survey, $);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('bootstrapslider')) widgets.bootstrapslider(survey);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('datepicker'))
    widgets.jqueryuidatepicker(survey, $);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('editor')) widgets.ckeditor(survey);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('maskedit')) widgets.inputmask(survey);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('nouislider')) widgets.nouislider(survey);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('pretty-checkbox')) widgets.prettycheckbox(survey);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('select2')) widgets.select2(survey, $);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('sortablelist')) widgets.sortablejs(survey);
  if (!survey.CustomWidgetCollection.Instance.getCustomWidgetByName('tagbox')) widgets.select2tagbox(survey, $);
};

const SurveyCustomWidgets = {
  //GeoLocationWidget,
  register,
};

export default SurveyCustomWidgets;
